/* eslint brace-style: 0 */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import SearchInput from './search_input';
import { isEmpty, includes } from 'lodash';
import { getRelativePath } from '../../utils/url';

const SearchIcon = (<svg width="16" height="18" viewBox="0 0 16 18" fill="black" xmlns="http://www.w3.org/2000/svg"><path d="M10.7857 8.71429C10.7857 6.50893 8.99107 4.71428 6.78571 4.71428C4.58036 4.71428 2.78571 6.50893 2.78571 8.71429C2.78571 10.9196 4.58036 12.7143 6.78571 12.7143C8.99107 12.7143 10.7857 10.9196 10.7857 8.71429ZM15.3571 16.1429C15.3571 16.7679 14.8393 17.2857 14.2143 17.2857C13.9107 17.2857 13.6161 17.1607 13.4107 16.9464L10.3482 13.8929C9.30357 14.6161 8.05357 15 6.78571 15C3.3125 15 0.5 12.1875 0.5 8.71429C0.5 5.24107 3.3125 2.42857 6.78571 2.42857C10.2589 2.42857 13.0714 5.24107 13.0714 8.71429C13.0714 9.98214 12.6875 11.2321 11.9643 12.2768L15.0268 15.3393C15.2321 15.5446 15.3571 15.8393 15.3571 16.1429Z" fill="#333333" /></svg>)

export default class SearchForm extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = { query: this.props.defaultValue };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    /* If the query is in sync with the props, who cares? */
    if (nextProps.defaultValue === this.state.query) {
      return;
    }
    /* If the defaultValue is blank, then the input should be reset. */
    else if (isEmpty(nextProps.defaultValue) && !isEmpty(this.state.query)) {
      this.setState({ query: '' });
    }
    /* Otherwise, the input should be updated to the new defaultValue. */
    else if (nextProps.defaultValue !== this.props.defaultValue) {
      this.setState({ query: nextProps.defaultValue });
    }
  }

  shouldComponentUpdate = (nextProps, nextState) =>
    nextProps.defaultValue !== this.props.defaultValue
    || nextState.query !== this.state.query
    || nextProps.isActive !== this.props.isActive;

  handleChange = (event) =>
    this.setState({ query: event.currentTarget.value });

  handleSubmit = (event) => {
    event.preventDefault();
    const query = this.state.query;

    if (!this.shouldMakeAPIRequest()) {
      return;
    }

    if (this.props.handleSubmit) {
      this.props.handleSubmit(
        event,
        query
      );
    }

    /*
     * Dispatching this action ensures that all search forms are filled in with
     * the new search term before the API response gets back. We could use
     * location.query.q, but Redux state probably works better with the Google
     * cached version of the page, and other sites that try to load Rosetta
     * externally.
     */
    this.props.recordSearchTerm(query);
    // Give GA time to register the event before moving routes
    setTimeout(() => {
      this.context.router.push({
        pathname: this.getSearchPath(),
        method: 'GET',
        query: { q: query }
      });
    }, 2000);

  };

  shouldMakeAPIRequest = () => !includes([
    '',
    this.props.defaultValue,
    this.context.location.query.q
  ], this.state.query);

  getSearchPath = () =>
    getRelativePath('/search', this.context.edition_data);


  render = () => (
    <form className="search-form" action={this.getSearchPath()} method="GET" onSubmit={this.handleSubmit} aria-label="Search">
      <SearchInput
        id={this.props.id}
        value={this.state.query}
        placeholderMessage={this.props.placeholderMessage}
        handleChange={this.handleChange}
      />
      <div className="search-button" role="button" onKeyPress={this.handleSubmit} onClick={this.handleSubmit} tabIndex="0" aria-label="search button">
        {SearchIcon}
      </div>
    </form>
  );
}

SearchForm.propTypes = {
  id: PropTypes.string,
  defaultValue: PropTypes.string.isRequired,
  handleSubmit: PropTypes.func,
  placeholderMessage: PropTypes.object.isRequired,
  shouldRenderSubmitButton: PropTypes.bool.isRequired,
  recordSearchTerm: PropTypes.func.isRequired,
  isActive: PropTypes.bool
};

SearchForm.defaultProps = {
  defaultValue: '',
  shouldRenderSubmitButton: false
};

SearchForm.contextTypes = {
  location: PropTypes.object,
  router: PropTypes.object,
  edition_data: PropTypes.object
};
